if (!customElements.get('variant-group-linker')) {
  customElements.define('variant-group-linker', class VariantGroupLinker extends HTMLElement {
    constructor() {
      super();

      this.select = this.querySelector('#variantGroupLinker');
      if (!this.select) return;

      this.currentColor = this.select.getAttribute('data-current-color');
      this.currentSize = this.select.getAttribute('data-current-size');
      this.options = Array.from(this.select.querySelectorAll('option'));

      this.colorPickersContainer = this.querySelector('[data-pickers-for="color"]');
      this.sizePickersContainer = this.querySelector('[data-pickers-for="size"]');

      this.init();
    }

    init() {
      // Check and disable unavailable variants
      // if both color and size variants are used
      if (this.colorPickersContainer && this.sizePickersContainer) {
        this.checkAvailableSizes();
        this.checkAvailableColors();
      } else {
        // Remove not-available classes from all if no check is performed
        this.querySelectorAll('.linkerBtn').forEach(btn => {
          btn.classList.remove('not-available');
        });
      }

      // Attach event listeners to all picker buttons
      this.querySelectorAll('.linkerBtn').forEach(btn => {
        btn.addEventListener('click', this.handleButtonClick.bind(this));
      });
    }

    checkAvailableSizes() {
      // Check available sizes according to the selected color
      this.options.forEach(option => {
        const optionColor = option.getAttribute('data-color');
        if (optionColor === this.currentColor) {
          const availableSize = option.getAttribute('data-size');
          const sizeButton = this.querySelector(`[data-picker-type="size"][data-picker-value="${availableSize}"]`);
          if (sizeButton) {
            sizeButton.classList.remove('not-available');
          }
        }
      });
    }

    checkAvailableColors() {
      // Check available colors - enable if available in any size
      const availableColors = new Set();
      this.options.forEach(option => {
        const availableColor = option.getAttribute('data-color');
        if (availableColor) {
          availableColors.add(availableColor);
        }
      });
      
      availableColors.forEach(color => {
        const colorButton = this.querySelector(`[data-picker-type="color"][data-picker-value="${color}"]`);
        if (colorButton) {
          colorButton.classList.remove('not-available');
        }
      });
    }

    handleButtonClick(event) {
      const button = event.currentTarget;
      const btnType = button.getAttribute('data-picker-type');
      const btnValue = button.getAttribute('data-picker-value');
      const prevColor = this.currentColor;
      const prevSize = this.currentSize;
      let changeUrl = false;
      let newUrl;

      if (btnType === 'color' && btnValue !== this.currentColor) {
        this.currentColor = btnValue;
        // First try to find option with new color and current size
        let option = this.options.find(opt =>
          opt.getAttribute('data-color') === this.currentColor &&
          opt.getAttribute('data-size') === this.currentSize
        );
        
        // If not found, find first available size for this color
        if (!option) {
          option = this.options.find(opt =>
            opt.getAttribute('data-color') === this.currentColor
          );
          // Update current size to match the found option
          if (option) {
            this.currentSize = option.getAttribute('data-size');
          }
        }
        
        newUrl = option ? option.getAttribute('data-url') : undefined;
        changeUrl = true;

      } else if (btnType === 'size' && btnValue !== this.currentSize) {
        this.currentSize = btnValue;
        const option = this.options.find(opt =>
          opt.getAttribute('data-color') === this.currentColor &&
          opt.getAttribute('data-size') === this.currentSize
        );
        newUrl = option ? option.getAttribute('data-url') : undefined;
        changeUrl = true;
      }

      if (changeUrl && newUrl !== undefined) {
        window.location.href = window.location.origin + newUrl;
      } else if (
        (newUrl === undefined && btnType === 'color' && btnValue !== prevColor) ||
        (newUrl === undefined && btnType === 'size' && btnValue !== prevSize)
      ) {
        // No redirect - reset values - show note
        this.currentColor = prevColor;
        this.currentSize = prevSize;

        const pickerContainer = this.querySelector(`[data-pickers-for="${btnType}"]`);
        const notAvailableNote = pickerContainer ? pickerContainer.querySelector('.not-available-note') : null;

        if (notAvailableNote) {
          notAvailableNote.classList.remove('not-visible', 'fade-out');

          setTimeout(() => {
            notAvailableNote.classList.add('not-visible', 'fade-out');
          }, 3000);
        }
      }
    }
  });
}
